module.exports = __webpack_public_path__ + "static/media/ladies_accessories_5.405f52ef.jpg";